import * as React from 'react'
import { mount, route, redirect } from 'navi'

// home List
import { getHomeList } from './components/activities-list/api'
import { ActivityList } from './components/activities-list/Activity'

import { ActivityDetail } from './components/activity_detail/activity_detail'

import { getVoteRule } from './components/activity_rule/api'
import { ActivityRule } from './components/activity_rule/rule'

import { OptionDetail } from './components/activity_option_detail/option'

import { ActivityRank } from './components/activity_rank/activity_rank'

import { ActivityComment } from './components/activity_comment/comment'

const routes = mount({
    '/': redirect("/list"),
    // 列表页
    '/list': route({
        getData: () => getHomeList(),
        view: <ActivityList />
    }),
    // 详情页
    '/group/:groupId/detail/:detailId': route(req => {
        let { groupId } = req.params
        const {  detailId } = req.params
        if(groupId>="101" && groupId<="138"){
            groupId = "43"
        }
        return {
            view: <ActivityDetail groupId={groupId} detailId={detailId} />
        }
    }),
    '/group/:groupId/detail/:detailId/:random': route(req => {
        let { groupId } = req.params
        const {  detailId } = req.params
        if(groupId>="101" && groupId<="138"){
            groupId = "43"
        }
        return {
            view: <ActivityDetail groupId={groupId} detailId={detailId} />
        }
    }),
    // 规则页面
    '/detail/:id/info': route(req => {
        const { id } = req.params
        return {
            data: getVoteRule(id),
            view: <ActivityRule id={id} />
        }
    }),
    '/detail/:id/info/:optionid': route(req => {
        const { id, optionid } = req.params
        return {
            view: <OptionDetail id={id} option={optionid} />
        }
    }),
    '/detail/:id/info/:optionid/:random': route(req => {
        const { id, optionid } = req.params
        return {
            view: <OptionDetail id={id} option={optionid} />
        }
    }),
    // 排名页面
    '/group/:groupId/detail/:detailId/rank': route(req => {
        const { groupId, detailId } = req.params
        return {
            view: <ActivityRank groupId={groupId} detailId={detailId} />
        }
    }),
    // 评论页面
    '/comments/:groupId/detail/:detailId': route(async req => {
        const { groupId, detailId } = req.params
        return {
            view: <ActivityComment groupId={groupId} detailId={detailId} />
        }
    })
})

export default routes


// WEBPACK FOOTER //
// ./src/routes.tsx